module.exports = __webpack_public_path__ + "img/people.4efb8004.png";